




import { Component, Vue, Prop } from 'vue-property-decorator';

import {
  TProgramStatusStatus,
  EProgramStatusStatus
} from '@/models/program-status';
import StatusTag from '../StatusTag/StatusTag.vue';

@Component({
  components: {
    StatusTag
  }
})
export default class ProgramStatusTag extends Vue {
  @Prop({ default: EProgramStatusStatus.PENDING })
  status!: TProgramStatusStatus;

  @Prop() inactive!: boolean;

  get tagName() {
    if (
      (this.status as any) === EProgramStatusStatus.INACTIVE &&
      !this.inactive
    )
      return EProgramStatusStatus.FAILED;
    if (this.inactive) return EProgramStatusStatus.INACTIVE;
    if ((this.status as any) === EProgramStatusStatus.PENDING)
      return 'processing';

    return this.status;
  }
}
